// @flow
import React, { Component } from "react";
import SiteTshirtTabs from "./SiteTshirtTabs";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import type { SitePage } from "../../types";

const styles = (theme) => ({
  divider: {
    height: theme.spacing(3),
  },
});

class SiteTshirtReport extends Component<SitePage, State> {
  render() {
    return (
      <Grid container spacing={2} justify="center">
        <Grid item xs={10}>
          <Typography variant="subtitle1">TSHIRT REPORT</Typography>
          <Typography variant="h4" color="textSecondary">
            {this.props.match.params.siteId}
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <div>
            <SiteTshirtTabs
              siteId={this.props.match.params.siteId}
              {...this.props}
            />
          </div>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(SiteTshirtReport);
